import api from './api';

export const getTags = (params) => api.get('/tags/', { params });
export const getTag = (id) => api.get(`/tags/${id}`);
export const getTagsList = (params) => api.get('/tags/list', { params });
export const getTagOptions = (params) => api.get('/tags/options', { params });
export const createTag = (data) => api.post('/tags', data);
export const updateTag = (id, data) => api.put(`/tags/${id}`, data);
export const deleteTag = (id) => api.delete(`/tags/${id}`);
export const syncTags = (data) => api.post('/tags/sync', data);

export const removeContactFromTag = (tagId, contactId) =>
  api.delete(`/tags-contacts/${tagId}/${contactId}`);

export const removeTicketTag = (ticketId) => api.delete(`/ticket-tags/${ticketId}`);
export const setTicketTag = (ticketId, tagId) => api.put(`/ticket-tags/${ticketId}/${tagId}`);
